import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../Context/AuthContext';
import RequestModal from '../Modals/FinalizedRequestModal';
import { toast } from 'react-toastify';

import { Card, Container, Row, Col, Button, Form } from 'react-bootstrap';

import { timestampToHTMLDateInput/*, HTMLDateInputToTimestamp, currentTimeStamp*/ } from '../HelperFunctions/dateConverters';

import { db } from '../firebase-config';
import { collection, query, getDocs, onSnapshot, where, doc, getDoc, setDoc/*, orderBy, limit*/} from 'firebase/firestore';

import StatusSpinner from '../Components/StatusSpinner';

export default function EmployeeFinalized() {
    const { setShowSpinner, showSpinner } = useAuth();
    const [listOfWorkOrders, setListOfWorkOrders] = useState([]);
    const [chosenRequest, setChosenRequest] = useState({});
    const chosenRequestId = useRef("");
    const [currentWorkOrderHours, setCurrentWorkOrderHours] = useState([]);
    // const [currentHeading, setCurrentHeading] = useState('Last 10 Finalized Work Orders');
    const [modalShow, setModalShow] = useState(false);
    const [defaultTruckCharge, setDefaultTruckCharge] = useState("");
    const [defaultDailyRates, setDefaultDailyRates] = useState({Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"});
    
    const [searchCriteria, setSearchCriteria] = useState("");
    //const searchInputRef = useRef(null);
    const [searchCount, setSearchCount] = useState(0);
    // const [where, setWhere] = useState("complete_timestamp");
    // const [whereOptions, setWhereOptions] = useState([]);
    // const [orderBy, setOrderBy] = useState("");
    // const [workOrderSearch, setWorkOrderSearch] = useState("");
    // const [limitSearch, setLimitSearch] = useState(10);

    const [currentClientInfo, setCurrentClientInfo] = useState({});

    const [usageOverride, setUsageOverride] = useState(false);


    useEffect(()=>{
        setShowSpinner(true);
        // const q = query(collection(db, "finalized_work_orders"), orderBy("complete_timestamp", "desc"), limit(10));
        const q = query(collection(db, "finalized_work_orders"));
        const unsubscribe =  onSnapshot(q, async (querySnapshot)=>{
            console.log('subscribe to finalized snapshot');
            setShowSpinner(false);
            let tempListOfWorkOrders = [];
            querySnapshot.forEach((order)=>{
                tempListOfWorkOrders = [...tempListOfWorkOrders, {data: order.data(), id: order.id}];
                if(order.id === chosenRequestId.current){
                    if(order.data()?.in_use === false){
                        setModalShow(false);
                    }
                }
            });
            tempListOfWorkOrders.sort((a,b) => {
                if(a.data.work_order.order_number > b.data.work_order.order_number) return 1;
                if(a.data.work_order.order_number < b.data.work_order.order_number) return -1;
                return 0;
            });
            setListOfWorkOrders(tempListOfWorkOrders);
        }, (error)=>{
            setShowSpinner(false);
            toast.error(`Failed to load data: ${error.message}`);
        });

        return ()=>{
            console.log("unsubscribe to snapshot");
            unsubscribe();
        }
    }, [setShowSpinner]);

    const loadHours = (requestID)=>{
        return new Promise(async (resolve, reject)=>{
          setShowSpinner(true);
          try{
            let hoursData = [];
            const q = query(collection(db, "hours"), where("requestID", "==", requestID));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc)=>{
              hoursData = [...hoursData, doc.data()];
            });
            resolve(hoursData);
          }catch(error){
            reject(error.message);
          }
          setShowSpinner(false);
        });
    };
    const loadRates = ()=>{
        return new Promise(async (resolve, reject)=>{
            setShowSpinner(true);
            getDocs(collection(db, "rates")).then((snapShot)=>{
                let tempTruckCharge = "0";
                let tempDailyRates = {Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"};
                snapShot.forEach((doc)=>{
                    if(doc.id === 'truck'){
                        tempTruckCharge = doc.data().rate;
                    }
                    if(doc.id === 'daily_tech_rates'){
                        tempDailyRates = doc.data();
                    }
                });
                return {truckCharge: tempTruckCharge, dailyRates: tempDailyRates};
            }).then((info)=>{
                setShowSpinner(false);
                setDefaultTruckCharge(info.truckCharge);
                setDefaultDailyRates(info.dailyRates);
                resolve('complete');
            }).catch((error)=>{
                setShowSpinner(false);
                toast.error(`Error getting rates list: ${error.message}`);
                reject(error.message);
            });
        });
    };

    const loadClientInfo = (client_id, client_location_id)=>{
        // load customer profile and location profile information once for use, only update if props changes
        // props?.request?.data?.client_id
        // props?.request?.data?.client_location_id
        return new Promise(async (resolve, reject)=>{
          if(client_id !== undefined && client_id !== "" && client_id !== null){
            setShowSpinner(true);
            try{
              const docRef = doc(db, "client_information", client_id);
              const docSnap = await getDoc(docRef)
              setShowSpinner(false);
              if(docSnap.exists()){
                let tempClientInfo = {...docSnap.data()}
                delete tempClientInfo.Locations;
                if(client_location_id !== undefined && client_location_id !== "" && client_location_id !== null){
                  const locInfo = docSnap.data().Locations.filter(elem => elem.id === client_location_id);
                  if(locInfo.length > 0){
                    resolve({client_info: tempClientInfo, location_info: locInfo});
                  }else{
                    toast.info('Location no longer exists');
                    resolve({client_info: tempClientInfo, location_info: []})
                  }
                } else{
                  toast.info('No linked location');
                  resolve({client_info: tempClientInfo, location_info: []})
                }
                
              }else{
                toast.info(`Client no longer exists`);
                resolve({client_info: {}, location_info: []});
              }
            }catch(error){
              setShowSpinner(false);
              toast.error(`Failed to load client data: ${error.message}`);
              resolve({client_info: {}, location_info: []});
            }
          }else{
            toast.info('No linked Client Profile');
            resolve({client_info: {}, location_info: []});
          }
        });
        // will need to know if override is given as to not reoverride when modal loads again
        // maybe remove client database link or location database link
    };

    const inUse = (workOrderId) =>{
        return new Promise(async (resolve, reject)=>{
            const WO = listOfWorkOrders.find(wo => wo.id === workOrderId).data;
            let tempWO = {...WO};
            tempWO.in_use = true;
            try{
                const docRef = doc(db, 'finalized_work_orders', workOrderId);
                setDoc(docRef, tempWO);
                resolve("saved");
            }catch(err){
                resolve("failed to save");
            }
            
        });
    };

    const notInuse = (workOrderId) =>{
        return new Promise(async (resolve, reject)=>{
            const WO = listOfWorkOrders.find(wo => wo.id === workOrderId).data;
            let tempWO = {...WO};
            tempWO.in_use = false;
            try{
                const docRef = doc(db, 'finalized_work_orders', workOrderId);
                setDoc(docRef, tempWO);
                resolve("saved");
            }catch(err){
                resolve("failed to save");
            }
            
        });
    };

    const setSearchTerm = (inputText)=>{
        if(inputText !== null && inputText !== undefined){
            setSearchCriteria(inputText.toLowerCase());
            const lowerCaseSearchTerm = inputText.toLowerCase();
            const filtered = listOfWorkOrders.filter(workorder =>
                workorder.data.type.toLowerCase().includes(lowerCaseSearchTerm) || 
                workorder.data.work_order.service_at.toLowerCase().includes(lowerCaseSearchTerm) ||
                workorder.data.work_order.order_number.toLowerCase().includes(lowerCaseSearchTerm) ||
                timestampToHTMLDateInput(workorder.data.complete_timestamp).toLowerCase().includes(lowerCaseSearchTerm) ||
                workorder.data.work_order.customer.toLowerCase().includes(lowerCaseSearchTerm) ||
                workorder.data.work_order.cust_auth_contact.toLowerCase().includes(lowerCaseSearchTerm)
            );

            setSearchCount(filtered.length);
        }
    };

    const clearSearch = ()=>{
        setSearchCriteria("");
        setSearchCount(listOfWorkOrders.length);
    };

    return(
        <>
            <Container fluid style={{width:"100%", paddingLeft:"65px", marginRight:"65px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center" style={{width:"100%"}}>
                        FINALIZED WORK ORDERS
                    </Row>
                </Container>
            </Container>
            <Container fluid className="mt-4" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Row className="justify-content-center" style={{width:"100%"}}>
                    <Col lg="1">Search:</Col>
                    <Col lg="4"><Form.Control type="text" value={searchCriteria} onChange={(e)=>setSearchTerm(e.target.value)} /></Col>
                </Row>
                <Row className="justify-content-center" style={{width:"100%"}}>
                    <Col lg="1">
                        <Button
                            className="btn-dark"
                            style={{backgroundColor:"#2596be", margin:5}}
                            onClick={()=>{
                                clearSearch();
                            }}
                        >
                            Clear
                        </Button>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="mt-4" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Row>
                    <Col lg="12">
                        <Card style={{border:"1px solid black"}}>
                            <Card.Header style={{textAlign:"center"}}>To be Invoiced {searchCount !== null && searchCount !== 0 && searchCount !== undefined && searchCount !== listOfWorkOrders.length  ? ` - Showing: ${searchCount} of ${listOfWorkOrders.length}` : ` - Count: ${listOfWorkOrders.length}`}</Card.Header>
                            <Card.Body style={{textAlign:"left"}}>
                            {
                                listOfWorkOrders.map((workorder, index)=>{
                                    return(
                                        searchCriteria === "" ?
                                            <div
                                                key={index}
                                                style={{cursor:"pointer", borderBottom:"1px solid lightgrey", color: workorder.data?.in_use ? "red" : "black", paddingTop:20}}
                                                onClick={async ()=>{
                                                    if(!workorder.data?.in_use){
                                                        try{
                                                            let hoursData = await loadHours(workorder.id);
                                                            await loadRates(); 
                                                            const clientInfo = await loadClientInfo(workorder.data?.client_id, workorder.data?.client_location_id);
                                                            const inUseResponse = await inUse(workorder.id);
                                                            console.log(inUseResponse);
                                                            console.log(hoursData);
                                                            console.log(clientInfo);
                                                            setCurrentClientInfo(clientInfo);
                                                            setCurrentWorkOrderHours(hoursData);
                                                            setChosenRequest(workorder);
                                                            chosenRequestId.current = workorder.id;
                                                            setModalShow(true);
                                                        }catch(error){
                                                            toast.error(`Failed to load hours: ${error}`);
                                                        }
                                                    }else if(usageOverride){
                                                        setUsageOverride(false);
                                                        if(window.confirm(`Are you sure you want to override the current user for Client: ${workorder.data['client name']}, they will lose any unsaved work`)){
                                                            try{
                                                                const notInUse = await notInuse(workorder.id);
                                                                console.log(notInUse);
                                                            }catch(error){
                                                                toast.error(`Failed to override`);
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                {timestampToHTMLDateInput(workorder.data.complete_timestamp)} - {workorder.data.type.toUpperCase()}: {workorder.data.work_order.service_at} - {workorder.data.work_order.order_number}{workorder.data?.in_use && " - in use"}
                                            </div>
                                        :
                                            workorder.data.type.toLowerCase().includes(searchCriteria.toLowerCase()) || 
                                            workorder.data.work_order.service_at.toLowerCase().includes(searchCriteria.toLowerCase()) ||
                                            workorder.data.work_order.order_number.toLowerCase().includes(searchCriteria.toLowerCase()) ||
                                            timestampToHTMLDateInput(workorder.data.complete_timestamp).toLowerCase().includes(searchCriteria.toLowerCase()) ||
                                            workorder.data.work_order.customer.toLowerCase().includes(searchCriteria.toLowerCase()) ||
                                            workorder.data.work_order.cust_auth_contact.toLowerCase().includes(searchCriteria.toLowerCase())
                                            ?
                                                <div
                                                    key={index}
                                                    style={{cursor:"pointer", borderBottom:"1px solid lightgrey", color: workorder.data?.in_use ? "red" : "black", paddingTop:20}}
                                                    onClick={async ()=>{
                                                        if(!workorder.data?.in_use){
                                                            setUsageOverride(false);
                                                            try{
                                                                let hoursData = await loadHours(workorder.id);
                                                                await loadRates(); 
                                                                const clientInfo = await loadClientInfo(workorder.data?.client_id, workorder.data?.client_location_id);
                                                                const inUseResponse = await inUse(workorder.id);
                                                                console.log(inUseResponse);
                                                                console.log(hoursData);
                                                                console.log(clientInfo);
                                                                setCurrentClientInfo(clientInfo);
                                                                setCurrentWorkOrderHours(hoursData);
                                                                setChosenRequest(workorder);
                                                                chosenRequestId.current = workorder.id;
                                                                setModalShow(true);
                                                            }catch(error){
                                                                toast.error(`Failed to load hours: ${error}`);
                                                            }
                                                        }else if(usageOverride){
                                                            setUsageOverride(false);
                                                            if(window.confirm(`Are you sure you want to override the current user for Client: ${workorder.data['client name']}, they will lose any unsaved work`)){
                                                                try{
                                                                    const notInUse = await notInuse(workorder.id);
                                                                    console.log(notInUse);
                                                                }catch(error){
                                                                    toast.error(`Failed to override`);
                                                                }
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {timestampToHTMLDateInput(workorder.data.complete_timestamp)} - {workorder.data.type.toUpperCase()}: {workorder.data.work_order.service_at} - {workorder.data.work_order.order_number}{workorder.data?.in_use && " - in use"}
                                                </div>
                                            :
                                                ""
                                    )
                                })
                            }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className="flex align-items-center justify-content-center" style={{minHeight: "10vh"}}>
                <Row className="mt-2">
                    <div>
                        Override Usage <input type="checkbox" checked={usageOverride} onChange={()=>setUsageOverride(!usageOverride)}/>
                    </div>
                </Row>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
            <RequestModal
                show={modalShow}
                onHide={async (cancelBit, updateOrderButtonStatus, invoiced)=> {
                    if(cancelBit === 'show cancel' && updateOrderButtonStatus === 'save'){
                        toast.warn(`Canceled: No changes were made to the work order.`);
                    }
                    if(!invoiced){
                        const WO = listOfWorkOrders.find(wo => wo.id === chosenRequest.id).data;
                        let tempWO = {...WO};
                        tempWO.in_use = false;
                        try{
                            const docRef = await doc(db, 'finalized_work_orders', chosenRequest.id);
                            setDoc(docRef, tempWO);
                        }catch(err){
                            console.log(err);
                        }
                    }

                    setChosenRequest({});
                    chosenRequestId.current = "";
                    setModalShow(false);
                }}
                request={chosenRequest}
                currentworkorderhours={currentWorkOrderHours}
                currentclientinfo={currentClientInfo}
                defaultdailyrates={defaultDailyRates}
                defaulttruckcharge={defaultTruckCharge}
                setcurrentworkorderhours={setCurrentWorkOrderHours}
            />
        </>
    )
}